import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import { RadioButton, RadioGroup } from 'src/components/atoms/input/RadioButton'
import { StoreProps } from 'src/stores'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { GoogleMapSearchBox } from 'src/components/molecules/configurator/GoogleMapSearchBox'
import FormContainer from 'src/components/containers/FormContainer'
import { LightBlueBtn } from 'src/components/atoms/input/buttons'
import { TInput as WizardTextInput } from 'src/components/atoms/input/TextInput'
import { media } from 'src/utils.js'
import backend from 'src/api'
const funeralPin = require('src/assets/configurator/map_marker_funeral.png')
const treePin = require('src/assets/configurator/map_marker_tree.png')
const seaPin = require('src/assets/configurator/map_marker_sea.png')

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class LocationFuneral extends React.Component<Props, any> {
  constructor(props) {
    super(props)
    const { confStore } = props
    const prevValue = confStore.getOffer.graveyard
    this.state = {
      mapOptions: this.mapsDefaultOptions(),
      maps: null,
      apiReady: false,
      alreadyOwnGrave: !!prevValue.alreadyOwnGrave,
      graveyards: [],
      selectedUuid: prevValue.uuid || null,
      graveyardInfo: prevValue || null,
      customName: prevValue.name || '',
      customZip: prevValue.zipCode || '',
      customCity: prevValue.address || ''
    }
  }

  componentDidMount() {
    this.loadGraveyards()
  }

  mapsDefaultOptions = () => {
    const { confStore } = this.props
    const graveyardLocation = confStore.getOffer.graveyard
    const offerLocation = confStore.getOffer.location
    return {
      center: {
        lat:
          parseFloat(graveyardLocation.latitude) ||
          parseFloat(offerLocation.latitude) ||
          47.418939,
        lng:
          parseFloat(graveyardLocation.longitude) ||
          parseFloat(offerLocation.longitude) ||
          13.061756
      },
      zoom:
        parseFloat(offerLocation.longitude) ||
        parseFloat(graveyardLocation.longitude)
          ? 13
          : 7
    }
  }

  mapApiLoaded = ({ _map, maps }) => {
    this.setState({ maps, apiReady: true })
  }

  loadGraveyards = () => {
    const { mapOptions } = this.state
    this.calculateGraveyards(
      parseFloat(mapOptions.center.lat),
      parseFloat(mapOptions.center.lng)
    )
  }

  calculateGraveyards = (centerLat, centerLng) => {
    const { confStore } = this.props
    backend.findAvailableGraveyards(confStore.getOffer.funeralType, centerLat, centerLng,
      (result) => {
      this.setState({ graveyards: result })
    })
  }

  handleMapChange = ({ center, zoom, _bounds }) => {
    this.calculateGraveyards(center.lat, center.lng)
    this.setState({ mapOptions: { center, zoom } })
  }

  handlePlaceSearched = (p) => {
    this.setState({
      mapOptions: {
        center: {
          lat: p.geometry.location.lat(),
          lng: p.geometry.location.lng()
        },
        zoom: 13
      }
    })
  }

  handleSelect = (e) => {
    const { confStore } = this.props
    const { alreadyOwnGrave, selectedUuid } = this.state
    if (selectedUuid === e) return
    // console.log(e)
    confStore.setOfferGraveyardbyObject(e)
    // Required as setting a new graveyard defaults own grave to false
    if (alreadyOwnGrave) confStore.setOfferGraveyardOwnGrave(true)
    const newGraveyard = confStore.getOffer.graveyard
    // console.log(newGraveyard)
    this.setState({
      selectedUuid: e,
      graveyardInfo: newGraveyard,
      mapOptions: {
        center: {
          lat: parseFloat(newGraveyard.latitude),
          lng: parseFloat(newGraveyard.longitude)
        }
      }
    })
  }

  handleDeselect = (e) => {
    e.preventDefault()
    const { confStore } = this.props
    confStore.setOfferGraveyardClear()
    // Only the selectedUuid is set to null so the map does
    // not move around but stays where it is. SelectedUuid is
    // thus also checked before displaying any graveyard information
    this.setState({
      selectedUuid: null,
      customName: '',
      customCity: '',
      customZip: ''
    })
  }

  decidePin = () => {
    const { confStore } = this.props
    const funeralType = confStore.getOffer.funeralType
    if (funeralType === 'TREE_FUNERAL') return treePin
    if (funeralType === 'SEA_FUNERAL') return seaPin
    return funeralPin
  }

  setCustomName = (e) => {
    this.setState({ customName: e.target.value })
  }

  setCustomZip = (e) => {
    this.setState({ customZip: e.target.value })
  }

  setCustomCity = (e) => {
    this.setState({ customCity: e.target.value })
  }

  saveCustomInput = () => {
    const { confStore } = this.props
    const { customCity, customName, customZip } = this.state
    confStore.setOfferGraveyard('name', customName)
    confStore.setOfferGraveyard('zipCode', customZip)
    confStore.setOfferGraveyard('address', customCity)
  }

  setAlreadOwnGrave = (value) => {
    const { confStore } = this.props
    this.setState({ alreadyOwnGrave: value })
    confStore.setOfferGraveyardOwnGrave(value)
  }

  renderCustomInput = () => {
    const { customCity, customName, customZip } = this.state
    return (
      <GraveyardInfoCustomInputContainer flex='row'>
        <Text>
          Ihr gewünschter Friedhof ist nicht dabei? Nennen Sie den
          Beisetzungsort einfach hier:
        </Text>
        <TextInput
          value={customName}
          placeholder='Friedhofsname'
          name='graveyard_name'
          onChange={this.setCustomName}
          onBlur={this.saveCustomInput}
        />
        <TextInput
          value={customZip}
          placeholder='PLZ'
          name='zipcode'
          onChange={this.setCustomZip}
          onBlur={this.saveCustomInput}
        />
        <TextInput
          value={customCity}
          placeholder='Ort'
          name='city'
          onChange={this.setCustomCity}
          onBlur={this.saveCustomInput}
        />
      </GraveyardInfoCustomInputContainer>
    )
  }

  renderGraveyardInfo = () => {
    const { graveyardInfo } = this.state
    return (
      <GraveyardInfoCustomInputContainer>
        <Text>
          <strong>Ihr gewählter Friedhof:</strong>
        </Text>
        <Text>{graveyardInfo.name}</Text>
        <Text>{graveyardInfo.address}</Text>
        <Text>
          {graveyardInfo.zipCode} {graveyardInfo.region}
        </Text>
      </GraveyardInfoCustomInputContainer>
    )
  }

  renderAlreadyOwnGraveInput = () => {
    const { alreadyOwnGrave } = this.state
    return (
      <GraveyardInfoCustomInputContainer style={{ float: 'right' }}>
        <Text>Ist bereits eine Grabstelle auf diesem Friedhof vorhanden?</Text>
        <RadioGroup style={{ width: '100%' }}>
          <RadioButton
            name='alreadyOwnGrave'
            label='Ja'
            value='YES'
            onClick={() => this.setAlreadOwnGrave(true)}
            defaultChecked={alreadyOwnGrave}
            inline
          />
          <RadioButton
            name='alreadyOwnGrave'
            label='Nein'
            value='NO'
            onClick={() => this.setAlreadOwnGrave(false)}
            defaultChecked={!alreadyOwnGrave}
            inline
          />
        </RadioGroup>
      </GraveyardInfoCustomInputContainer>
    )
  }

  render() {
    const { confStore, index } = this.props
    const { apiReady, maps, graveyards, mapOptions, selectedUuid } = this.state
    const funeralType = confStore.getOffer.funeralType
    return (
      <ConfiguratorBox
        title={`${index}. Ort der Bestattung`}
        idLabel='expand-arrow-location-funeral'
        collapsable>
        <GoogleMapContainer>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyC1FnqfxEtPCI6h1wg5iJ9EdOqtJbv1wxY',
              libraries: ['places']
            }}
            options={{ gestureHandling: 'greedy' }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={this.mapApiLoaded}
            center={mapOptions.center}
            zoom={mapOptions.zoom}
            onChange={this.handleMapChange}>
            {graveyards.map((e) => {
              return (
                <CemetryPin
                  key={e.uuid}
                  pin={this.decidePin()}
                  lat={parseFloat(e.latitude)}
                  lng={parseFloat(e.longitude)}
                  text={e.name}
                  onClick={() => {
                    this.handleSelect(e)
                  }}
                  selected={e.uuid === selectedUuid}
                />
              )
            })}
          </GoogleMapReact>
        </GoogleMapContainer>

        {apiReady && (
          <GoogleMapSearchBox
            googlemaps={maps}
            onChange={this.handlePlaceSearched}
          />
        )}

        {selectedUuid ? this.renderGraveyardInfo() : this.renderCustomInput()}

        {(funeralType === 'BURIAL' || funeralType === 'CREMATION' || funeralType === 'TREE_FUNERAL') &&
          this.renderAlreadyOwnGraveInput()}

        <WeakButton
          // If there is only one graveyard, this is default
          // and cannot be changed
          visible={!!selectedUuid && graveyards.length > 1}
          onClick={this.handleDeselect}>
          Auswahl aufheben
        </WeakButton>
      </ConfiguratorBox>
    )
  }
}

const GoogleMapContainer = styled.div`
  width: 100%;
  height: 500px;
  .gm-style-pbt {
    display: none;
  }
  ${media.desktop` height: 300px; `}
`

const CemetryPin = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  transform: translate(-50%, -50%);
  background-image: url(${(props) => props.pin});
  background-size: cover;
  cursor: pointer;
  z-index: ${(props) => (props.selected ? '5000' : '100')};

  &:hover::after {
    display: inline-block;
    position: absolute;
    padding: 10px 15px;
    font-size: 16px;
    color: white;
    text-align: center;
    background: #974353;
    border: 2px solid white;
    border-radius: 30px;
  }

  &::after {
    display: ${(props) => (props.selected ? 'inline-block' : 'none')};
    position: absolute;
    padding: 10px 15px;
    content: '${(props) => props.text}${(props) =>
  props.selected ? ' \u2713' : ''}';
    font-size: 16px;
    color: white;
    text-align: center;
    background: #974353;
    border: 2px solid white;
    border-radius: 30px;
    transform: translate(-35%, -20%);
    white-space: ${(props) => (props.selected ? 'nowrap' : 'wrap')};
  }
`

const Text = styled.p`
  width: 100%;
  margin: 0;
  text-align: left;
  &:first-child {
    padding: 10px 0;
  }
`

const GraveyardInfoCustomInputContainer = styled(FormContainer)`
  width: 48%;
  float: left;
  padding: 15px 5% 30px 5%;
  ${media.tablet`
    width: 100%;
    padding: 15px 5px;
  `}
`

const TextInput = styled(WizardTextInput)`
  padding: 0;
  padding-bottom: 3%;
  text-align: center;
`

const WeakButton = styled(LightBlueBtn)`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  width: 100%;
  max-width: 230px;
  margin: 10px auto;
  clear: both;
  background: transparent;
  border: 2px #9abbbf solid;
  font-size: 15px;
  color: #9abbbf;
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/LocationFuneral.tsx